<template>
  <div class="container p-0">
    <div class="row m-0">
      <div class="col-md-12 ml-auto p-0">
        <div class="accordion my-3" :id="accordionId">
          <AccordionItem :accordionId="accordionId"
                         v-for="(item, index) in accordionItems"
                         :key="index"
                         :item="item"
                         :index="index"
                         :item_list="item_list"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import AccordionItem from "@/components/AccordionItem";
import {generateUuidNo} from "@/util/helpers";

export default {
  name: "Accordion",
  components: {
    AccordionItem: AccordionItem,
  },
  props:{
    item_list:{
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      accordionId: "",
      accordionItems: [
        {
          title: '訂單明細',
        },
      ],
    };
  },
  created() {
    const randomNum = generateUuidNo();
    this.accordionId = `accordion_${randomNum}`;
  },
}
</script>

<style scoped>
.grid-gap {
  grid-gap: 10px;
}
</style>
